import routes from 'js/core_pre_webpack/routes';
import * as ApiUtils from 'js/utils/api_utils';
import { News, FollowableUser, NewsType } from '../shared/types';

// The next page params type should be invisible to the client, it's
// something that is set by the server for the client to pass back in
// order to retrieve the next page.
type NextPageParams = object | null;

interface NewsFeedResponse {
  posts: Array<News>;
  users: Array<FollowableUser>;
  meta: {
    next: NextPageParams;
    showJJHomePage?: boolean;
  };
  openalexRecsTestBucket?: string;
  extendedOnsiteRecsTestBucket?: string;
  recencyWeightedTestBucket?: string;
  guessTheResearcherTestBucket?: string;
  topicText?: string | null;
}

export type GetPageApi = (params: NextPageParams) => Promise<NewsFeedResponse>;

export const getSocialNewsFeedPage: GetPageApi = (params) =>
  ApiUtils.get(
    routes.api_v0_community_news_feed_path({
      subdomain_param: 'api',
    }),
    params || undefined,
  );

export const getSocialHashtagSearchPage =
  (hashtag: string): GetPageApi =>
  (params: NextPageParams) =>
    ApiUtils.get(
      routes.api_v0_community_hashtag_feed_path({
        subdomain_param: 'api',
        hashtag: hashtag,
      }),
      params || undefined,
    );

export const getProfileFeedPage =
  (userId: number, filter?: string): GetPageApi =>
  (params: NextPageParams) => {
    let finalParams: NextPageParams = params ?? {};
    if (filter !== undefined) {
      finalParams = { ...finalParams, filter };
    }
    return ApiUtils.get(
      routes.api_v0_community_profile_feed_path({
        subdomain_param: 'api',
        user_id: userId,
      }),
      finalParams,
    );
  };

export const getSingleNewsPage =
  (
    newsId: number | string | null,
    newsType: NewsType,
    commentId: number | string | null = null,
  ): GetPageApi =>
  (params: NextPageParams) => {
    const routeMap = {
      post: routes.api_v0_community_post_path,
      paper_update: routes.api_v0_community_paper_update_path,
      openalex_work: (_: any) => '',
      work: (_: any) => '',
      paper_set: (_: any) => '',
    };
    return ApiUtils.get(
      routeMap[newsType]({
        subdomain_param: 'api',
        id: newsId,
      }),
      commentId ? { comment_id: commentId, ...params } : { ...params },
    );
  };

export const getResearchInterestPostsPage = (
  interest_id: number,
  { pageSize = 10 }: { pageSize?: number } = {},
): GetPageApi => {
  return (params: NextPageParams) => {
    return ApiUtils.get(
      routes.api_v0_interest_posts_path({
        subdomain_param: 'api',
        interest_id,
        per: pageSize,
      }),
      params || undefined,
    );
  };
};
